<template>
    <div class="base-form-div">
        <el-form size="mini" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="指挥机卡号" prop="broadcastNumber">
                <el-select v-model="ruleForm.broadcastNumber" placeholder="请选择指挥机卡号">
                    <el-option v-for="item in listDirector" :key="item.cardNumber" :label="item.cardNumber"
                        :value="item.broadcastNumber">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="报文内容" prop="content">
                <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 4 }" placeholder="请输入报文内容"
                    v-model="ruleForm.content"></el-input>
            </el-form-item>
            <div class="form-bottom">
                <el-button class="base-button" size="mini" type="primary" @click="submitForm('ruleForm')">发送</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
import { getListDirector } from "@/api/device/index.js";
//{"broadcastNumber":1581950,"content":"111"}
//broadcastNumber 通播号     报文内容111
export default {
    props: ["subData"],
    data() {
        return {
            listDirector: [],
            ruleForm: {
                broadcastNumber: undefined,
                content: "",
            },
            rules: {
                broadcastNumber: [
                    { required: true, message: "请选择指挥机卡号", trigger: "change" },
                ],
                content: [
                    { required: true, message: "请输入报文内容", trigger: "blur" },
                ]
            },
        };
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$message({
                        message: "发送成功",
                        type: "success",
                    });
                    console.log(this.ruleForm);
                    this.$bus.$emit("sendMsg-CQ", this.ruleForm);
                    this.$parent.close();
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        getListDirector() {
            getListDirector().then(res => {
                this.listDirector = res.result || [];
            }).catch(err => {
                console.error(err);
            });
        }
    },
    created() {
        this.getListDirector()
    },
    mounted() { },
};
</script>
<style>
.form-bottom {
    margin-bottom: 0 !important;
    text-align: center;
}

.el-input-number {
    width: 100%;
}
</style>